// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-AccountContainer__accountTrigger__root cmp-components__clickable__root","label":"cmp-AccountContainer__accountTrigger__label"};